import * as yup from 'yup';
import i18n from '@i18n';

export const generateSchema = (field) =>
  yup.object().shape({
    [field]: yup.string().required(i18n('ERROR__COMMONS__REQUIRED_FIELD')),
  });
